
import { receiveProgress, closeSocket } from '../api/websocket'


export default function ( progressCallback ){

  //////////////////////////////////////////////////////////

  const watchProgress = ( actionId  ) =>{
    try{
      status = "Progress"
      receiveProgress( actionId, callback )
    }catch(e){
      callback(e)
    }
  }
  
  const closeProgress = () =>{
    closeSocket()
  }
  
  let status = ""
  let error = ""
  const callback = ( result ) =>{
    console.log( result )
    var results = result.split('@')

    let percent = 0

    //進捗を計算
    if( results[0] == "Progress"){      
      var progress = results[1].split(',')
      var total = new Number( progress[0] );
      var loaded = new Number( progress[1] );
      percent =  Math.floor(loaded / total * 100)
      
      progressCallback( results[0], [""], percent, status)
    }
    else if( results[0] == "Success" ){
      status = "Success"
      progressCallback( results[0], [""], null, status)
    }
    else if( results[0] == "Error" ){
      status = "Error"
      error = results[1]
      progressCallback( results[0], error, null, status)
    }
    else if( results[0] == "UnexpectedError" ){
      status = "UnexpectedError"
      error = results[1]
      progressCallback( results[0], error, null, status)
    }
    
    else if( results[0] == "Close" ){
      progressCallback( results[0], error, null, status)
    }
    else if( results[0] == "NewItem" ){
      status = "NewItem"
      var obj = JSON.parse(results[1]);
      progressCallback( results[0], [""], percent, status, obj)
    }
    else if( results[0] == "ProgressList" ){
      status = "ProgressList"
      progressCallback( results[0], [""], results[1], status, obj)
    }
    else if( results[0] == "Status" ){
      status = "Status"
      progressCallback( results[0], [""], results[1], status, obj)
    }
  }
  
  //////////////////////////////////////////////////////////


 
  //当該ライブラリが提供する変数、メソッドを宣言
  return{
    watchProgress,
    closeProgress
  }
}